import React from "react";
import styled from "styled-components/macro";
import { theme } from "./theme";

const UpperPanel = ({ children }) => {
  return (
    <Wrapper>
      <InnerWrapper>{children}</InnerWrapper>
      <Divider />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 24px 0;
`;
const Divider = styled.div`
  margin-top: 16px;
  height: 1px;
  background-color: ${theme.border};
`;

const InnerWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  min-height: 34px;
`;

export const UpperPanelBtn = styled.button`
  outline: none;
  display: flex;
  position: relative;
  align-items: center;
  gap: 6px;
  font-family: ${theme.fontFamily};
  font-size: 13px;
  font-weight: 500;
  color: ${({ color }) => color || theme.text};
  background-color: ${({ backgroundColor }) => backgroundColor || "transparent"};
  border: none;
  border-radius: ${theme.radiusSm};
  padding: 8px 14px;
  cursor: pointer;
  transition: background-color 150ms ease, transform 150ms ease;
  &:hover {
    background-color: ${({ backgroundColorHover }) =>
      backgroundColorHover || theme.primaryLight};
  }
  &:active {
    transform: scale(0.97);
  }
  &:disabled {
    cursor: default;
    opacity: 0.5;
  }
`;

export { UpperPanel };
